import { useState } from "react";
import { PaymentRedriveApiFactory } from "../lusca-search-api/LuscaSearchApiFactory";
import { AsyncStatus } from "../components/common/AsyncActionButton";
import { Stage } from "../lusca-search-api/generated-src/api";

export function usePaymentRedrive(stage: Stage) {
  const [status, setStatus] = useState(AsyncStatus.NOT_STARTED);
  const [error, setError] = useState<string>();

  const redrive = async (pk: string) => {
    setStatus(AsyncStatus.LOADING);
    try {
      const api = PaymentRedriveApiFactory();
      const blob = new Blob([pk], { type: "text/csv" });
      const file = new File([blob], "single_payment.csv", { type: "text/csv" });

      const uploadUrlResponse = await api.getPaymentRedriveUploadUrl(
        stage,
        file.name
      );
      if (
        !uploadUrlResponse.data?.uploadUrl ||
        !uploadUrlResponse.data?.s3Uri
      ) {
        throw new Error("Failed to get upload URL");
      }

      const uploadResponse = await fetch(uploadUrlResponse.data.uploadUrl, {
        method: "PUT",
        body: file,
        headers: { "Content-Type": "text/csv" },
      });
      if (!uploadResponse.ok) {
        throw new Error("Failed to upload file to S3");
      }

      const { data } = await api.postPaymentRedriveBulk(stage, {
        s3_uri: uploadUrlResponse.data.s3Uri,
      });
      if (data?.status === "PENDING") {
        setStatus(AsyncStatus.SUCCESSFUL);
      } else {
        setError("Unexpected response");
        setStatus(AsyncStatus.FAILED);
      }
    } catch (e) {
      const axiosError = e as { response?: { data?: { message?: string } } };
      const message =
        axiosError.response?.data?.message ||
        (e instanceof Error ? e.message : "Redrive failed");
      setError(message);
      setStatus(AsyncStatus.FAILED);
    }
  };

  return { status, error, redrive };
}
